import { FONT, FontStyleSheet } from '../font-style-sheets';
import { PrintCardMenu } from './print-card-menu';

export class HoneyHazePrintCardMenu extends PrintCardMenu {
  whatFontsAreNeededToRenderContent(): FontStyleSheet[] {
    return [FONT.Poppins.ExtraBold_800, FONT.Poppins.Regular_400];
  }

  override getAdobeFontFamilyCssUrl(): string | null {
    return 'https://use.typekit.net/oke1hxn.css';
  }
}
